/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_Tax_Id_HintInputs */

const en_invoice_request_tax_id_hint = /** @type {(inputs: Invoice_Request_Tax_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a company invoice, e.g. your NIP. Leave empty for a personal one.`)
};

const pl_invoice_request_tax_id_hint = /** @type {(inputs: Invoice_Request_Tax_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przy fakturze na firmę. Zostaw puste dla faktury imiennej.`)
};

/**
* | output |
* | --- |
* | "For a company invoice, e.g. your NIP. Leave empty for a personal one." |
*
* @param {Invoice_Request_Tax_Id_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_tax_id_hint = /** @type {((inputs?: Invoice_Request_Tax_Id_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_Tax_Id_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_tax_id_hint(inputs)
	return en_invoice_request_tax_id_hint(inputs)
});